import { useQuery } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";

export type Municipality = {
  gemeentecode: string;
  gemeentenaam: string;
};

const getMunicipalitiesQuery = () =>
  getTbiApi().getQueryOptions<Municipality[]>({
    queryKey: ["municipalities"],
    queryFn: async () => {
      return (await getTbiApi().BaseApi.fetchJson(
        "https://api.kadastralekaart.com/api/v1/municipality"
      )) as Municipality[];
    },
  });

export const useMunicipalitiesQuery = () => useQuery(getMunicipalitiesQuery());
